// Default client-side settings used when the Firebase /settings node is empty.
// This keeps the web and mobile apps functional (e.g., showing store links)
// until an admin saves real settings via the App Information screen.
const defaultSettings = {
  appName: 'PLUKK',
  code: 'USD',
  symbol: '$',
  decimal: 2,
  driver_approval: false,
  otp_secure: false,
  bonus: 10,
  convert_to_mile: false,
  CarHornRepeat: true,
  CompanyName: 'PLUKK',
  CompanyWebsite: 'https://reaplnprge.web.app',
  CompanyTerms: 'https://reaplnprge.web.app/privacy-policy',
  TwitterHandle: '',
  FacebookHandle: '',
  InstagramHandle: '',
  AppleStoreLink: 'https://apps.apple.com/app/id1501332146#?platform=iphone',
  PlayStoreLink: 'https://play.google.com/store/apps/details?id=com.pluck.customer',
  bank_fields: false,
  contact_email: '',
  AllowCriticalEditsAdmin: true,
  AllowCountrySelection: true,
  FacebookLoginEnabled: true,
  AppleLoginEnabled: true,
  autoDispatch: true,
  driverRadius: 10,
  country: 'India',
  RiderWithDraw: false,
  swipe_symbol: false,
  restrictCountry: '',
  negativeBalance: false,
  AllowDeliveryPickupImageCapture: true,
  AllowFinalDeliveryImageCapture: true,
  horizontal_view: false,
  showLiveRoute: true,
  mapLanguage: 'en',
  maintenanceMode: false,
  maintenanceMessage: 'We are performing scheduled maintenance. Please try again later.',
  CompanyAddress: 'Kolkata, India',
  CompanyPhone: '+919998887777',
  useDistanceMatrix: false,
  imageIdApproval: false
};

export default defaultSettings;
